import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import { TabsState } from 'ia-react-core/~/interfaces/TabsState';
import SelectTabById from 'ia-react-core/~/actions/tabs/SelectTabById';
import get from '../../../utils/accessors/get';
import set from '../../../utils/accessors/set';

import selectTabById from '../../../actions/tabs-fn/selectTabById';
import selectTabByName from '../../../actions/tabs-fn/selectTabByName';

export default function tabsReducer(state: TabsState, action: CoreAction) {
  const tabsId = get(state, 'tabsId');
  const name = get(state, 'name');

  switch (action.type) {
    case `${selectTabById.type}/${tabsId}`:
      return reduceSelectTab(state, (action as SelectTabById).selectedTab);
    case `${selectTabByName.type}/${name}`:
      return reduceSelectTab(state, (action as SelectTabById).selectedTab);
    default:
      return state;
  }
}

function reduceSelectTab(state: TabsState, selectedTab: string | number) {
  return set(state, 'selectedTab', selectedTab);
}
